import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleInfo } from 'src/shared/models/module-info.model';

@Component({
    selector: 'module-preview',
    templateUrl: './module-preview.component.html',
    styleUrls: ['./module-preview.component.scss']
})
export class ModulePreviewComponent implements OnInit, OnChanges {
    @Input() module: ModuleInfo;
    @Input() hoverIndex: string;
    @Input() continueShow: boolean;
    @Input() currentModuleid: number;
    @Input() isAddModuleDropdown: boolean;
    @Input() isSearch: boolean;
    @Input() top;
    @Input() left;
    @Input() ModuleGroup;

    acdTab: string = 'acd-color';
    qmTab: string = 'qm-color';
    analyticsTab: string =  'analytics-color';
    metricsTab: string = 'metrics-color';
    coachingTab: string = 'coaching-color';
    pmTab: string = 'pm-color';

    options = [];
    localizationDic = null;
    /* The `widgetsWithCustomForSection` array stores widgets that require custom descriptions specifically for the "For:" section in the description text */
    widgetsWithCustomForSection: string[] = ["CXone_Games_Tracker", "CXone_My_Ranking"];

    constructor(
        public cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.updateOptions();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hoverIndex) {
            this.updateFromLocalDic();
        }
    }

    private async updateOptions() {
        if (this.localizationDic == null) {
            try {
                this.localizationDic = await this.cvLocalizationService.GetSection("ModulePreview");
                this.updateFromLocalDic();
            }
            catch {
                if (this.module.options.tableAvailable) {
                    this.options.push("Table View");
                }
                if (this.module.options.chartAvailable) {
                    this.options.push("Chart View");
                }
                if (this.module.options.tableAndChartAvailable) {
                    this.options.push("Table & Chart");
                }
                this.updateFromLocalDic();
            }
        }
    }

    private updateFromLocalDic() {
        this.options = [];
        if (this.module.options != null && this.module.options.tableAvailable) {
            if (this.localizationDic?.get("Table_View") == null) {
                this.options.push("Table View");
            } else {
                this.options.push(this.localizationDic.get("Table_View"));
            }
        }
        if (this.module.options != null && this.module.options.chartAvailable) {
            if (this.localizationDic?.get("Chart_View") == null) {
                this.options.push("Chart View");
            } else {
                this.options.push(this.localizationDic.get("Chart_View"));
            }
        }
        if (this.module.options != null && this.module.options.tableAndChartAvailable) {
            if (this.localizationDic?.get("Table_And_Chart") == null) {
                this.options.push("Table & Chart");
            } else {
                this.options.push(this.localizationDic.get("Table_And_Chart"));
            }
        }
    }

    public getLocalizedDict(ModuleName) {
        return this.localizationDic?.get(ModuleName + 'Desc');
    }

    public getWidgetGroupSvgPath(iconName) {
        if (!iconName)
            return null;
        return `${window['_BaseURI']}/App_Themes/CXone/icons/widgets/${iconName}.svg#${iconName}`;
    }

    widgetGroupName(group) {
        switch (group){
        case 'performance' :
            return 'acd-color'
        case 'report':
            return 'qm-color'
        case 'tools':
            return 'analytics-color'
        case 'metrics':
            return 'metrics-color';
        case 'CXone_ACD' :
            return 'acd-color'
        case 'Metric_Visualization':
            return 'acd-color'
        case 'CXone_QM':
            return 'qm-color'
        case 'CXone_IA':
            return 'analytics-color'
        case 'CXone_Metrics':
            return 'metrics-color';
        case 'CXone_Coaching':
            return 'coaching-color';
        case 'coaching':
            return 'coaching-color';
        case 'CXone_PM':
            return 'pm-color';
        }
    }

    getWidgetDescriptionForSection(group, Name) {
        switch (group) {
            case 'performance':
                return 'ACD_For'
            case 'report':
                return 'QM_For'
            case 'tools':
                return 'Analytics_For'
            case 'metrics':
                return 'Metrics_For';
            case 'CXone_ACD':
                return 'ACD_For'
            case 'Metric_Visualization':
                return 'ACD_For'
            case 'CXone_QM':
                return 'QM_For'
            case 'CXone_IA':
                return 'Analytics_For'
            case 'CXone_Metrics':
                return 'Metrics_For';
            case 'CXone_Coaching':
                return 'Coaching_For';
            case 'coaching':
                return 'Coaching_For';
            case 'CXone_PM':
                return this.widgetsWithCustomForSection.includes(Name) 
                    ? this.getWidgetsWithCustomForSection(Name) 
                    : 'PM_For';
        }
    }

    getWidgetsWithCustomForSection(groupName) {
        switch (groupName) {
            case 'CXone_Games_Tracker':
                return 'CXone_For';
            case 'CXone_My_Ranking':
                return 'CXone_My_Ranking_For';
        }
    }
}
